import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Container, IconButton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { useLoadingContext } from '../../context/loadingContext';
import { MemberService } from '../../Services/member.service';

const MemberCard = () => {
  const navigate = useNavigate();
  const [card, setCard] = useState([]);
  const [notes, setNotes] = useState();
  const { handleStartLoading, handleStopLoading } = useLoadingContext();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    (async () => {
      try {
        handleStartLoading();
        const [dataCard, dataNote] = await Promise.all([
          MemberService.GetListMemberCard(),
          MemberService.GetMemberNotes(),
        ]);

        setCard(dataCard);
        setNotes(dataNote);
      } catch (e) {
        console.log(e);
      } finally {
        handleStopLoading();
      }
    })();
  }, []);

  const handleCreateMemberNotes = () => {
    MemberService.CreateMemberNotes()
      .then(() => {
        (async () => {
          try {
            handleStartLoading();
            const data = await MemberService.GetMemberNotes();
            setNotes(data);
          } catch (e) {
            console.log(e.response.data);
          } finally {
            handleStopLoading();
          }
        })();
        enqueueSnackbar('Thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }));
  };

  const handleDeleteMemberCard = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: 'Xóa thẻ thành viên',
      text: 'Thao tác này không thể hoàn tác',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Xóa',
      cancelButtonText: 'Hủy',
    }).then((res) => {
      if (res.isConfirmed) {
        MemberService.DeleteMemberCardById(id)
          .then(() => {
            setCard((prevState) => prevState.filter((item) => item._id !== id));
          })
          .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
          .finally(handleStopLoading);
      }
    });
  };

  return (
    <Page title="Thành viên">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Chi tiết chương trình
          </Typography>
          <Stack direction={'row'} spacing={1}>
            {!notes ? (
              <Button
                onClick={handleCreateMemberNotes}
                type="submit"
                variant="contained"
                startIcon={<Iconify icon="material-symbols:add" />}
              >
                Thêm
              </Button>
            ) : (
              <Button
                onClick={() => navigate('/member/notes')}
                type="submit"
                variant="contained"
                color={'warning'}
                startIcon={<Iconify icon={'material-symbols:edit'} />}
              >
                Cập nhật
              </Button>
            )}
          </Stack>
        </Stack>
        {notes && (
          <Card>
            <CardContent>
              <div className="ck-content" dangerouslySetInnerHTML={{ __html: notes && notes.description }} />
            </CardContent>
          </Card>
        )}
        <Stack mt={'32px'} direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Thẻ thành viên
          </Typography>
          <Stack direction={'row'} spacing={1}>
            <Button
              onClick={() => navigate('/member/create')}
              type="submit"
              variant="contained"
              startIcon={<Iconify icon="material-symbols:add" />}
            >
              Thêm
            </Button>
          </Stack>
        </Stack>
        <Stack spacing={3}>
          {card?.map((item) => (
            <Card key={item._id}>
              <Stack direction={{ xs: 'column', sm: 'row' }}>
                <img
                  style={{ height: '100%', width: '400px' }}
                  src={`${process.env.REACT_APP_IMAGE}/${item.image}`}
                  alt={item.code}
                />
                <CardContent sx={{ width: '100%' }}>
                  <Typography color={'#A7202C'} variant={'h4'}>
                    {item.code}
                  </Typography>
                  <Typography variant={'body2'} mt={'8px'}>
                    {item.description}
                  </Typography>
                  <Stack mt={'16px'} justifyContent={'space-between'} direction={'row'} alignItems={'center'}>
                    <Typography
                      color="#C89134"
                      variant="subtitle2"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => navigate(`/member/view/${item._id}`)}
                    >
                      Xem chi tiết <Iconify icon={'bi:arrow-right'} />
                    </Typography>
                    <Stack spacing={1} direction={'row'}>
                      <Button
                        onClick={() => handleDeleteMemberCard(item._id)}
                        variant={'contained'}
                        color={'error'}
                        startIcon={<Iconify icon="material-symbols:delete-rounded" />}
                      >
                        Xóa
                      </Button>
                      <Button
                        onClick={() => navigate(`/member/edit/${item._id}`)}
                        variant={'contained'}
                        color={'secondary'}
                        startIcon={<Iconify icon="bx:edit" />}
                      >
                        Cập nhật
                      </Button>
                    </Stack>
                  </Stack>
                </CardContent>
              </Stack>
            </Card>
          ))}
        </Stack>
      </Container>
    </Page>
  );
};

export default MemberCard;
